import { render } from "./ZapiPillButton.vue?vue&type=template&id=032915cc&scoped=true"
import script from "./ZapiPillButton.vue?vue&type=script&lang=js"
export * from "./ZapiPillButton.vue?vue&type=script&lang=js"

import "./ZapiPillButton.vue?vue&type=style&index=0&id=032915cc&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032915cc"]])

export default __exports__